<ng-container *ngIf="showPhone && group !== 'AVANS'">
  <button (click)="wayRepeat.emit(VerificationTypeEnum.PHONE)" class="btn btn_large btn_auto btn-not-bg" type="button">
    {{ 'button.repeatPhone' | translate }}
  </button>
  <p>{{ 'bankId.or' | translate }}</p>
</ng-container>
<button (click)="wayRepeat.emit(VerificationTypeEnum.SMS)" class="btn btn_large btn_auto btn-not-bg" type="button">
  {{ 'button.repeatSms' | translate }}
</button>
